import { Modal } from "@/common/components/modal"
import Form from "@/common/components/form/Form"
import { Button } from "@/common/components/button"
import { ToggleWrapper, ToggleLabel, ToggleInput, ToggleSlider, ButtonWrapper } from "../style"
import { getFormInputs } from "./data"

interface Props {
  isOpen: boolean
  onClose: () => void
  cluster: any
  submitLoading: boolean
  statusToggle: boolean
  onStatusToggle: (val: boolean) => void
  onSubmit: (formValues: any) => void
}

export default function EditClusterModal({
  isOpen,
  onClose,
  cluster,
  submitLoading,
  statusToggle,
  onStatusToggle,
  onSubmit,
}: Props) {
  return (
    <Modal title="Edit Cluster" isOpen={isOpen} close={onClose}>
      <div className="modal max-w-[600px] md:w-[600px] min-h-[300px] bg-white">
        <Form
          formInputs={getFormInputs(cluster)}
          processInputs={onSubmit}
          loadingState={submitLoading}
          submitLabel="Update"
          removeSubmitButton={true}
        />

        <ToggleWrapper>
          <label>Status</label>
          <ToggleLabel>
            <ToggleInput type="checkbox" checked={statusToggle} onChange={(e) => onStatusToggle(e.target.checked)} />
            <ToggleSlider checked={statusToggle} />
          </ToggleLabel>
        </ToggleWrapper>

        <ButtonWrapper>
          <Button
            loading={submitLoading}
            disabled={submitLoading}
            onClick={() => {
              const formElement = document.querySelector("form")
              if (formElement) {
                formElement.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }))
              }
            }}
          >
            Update
          </Button>
        </ButtonWrapper>
      </div>
    </Modal>
  )
}
